import React, { FunctionComponent } from 'react';
import { AwardCard } from 'scenes/common/components/Awards';

import { ClaimSupport } from 'scenes/common/components/ClaimSupport';
import { Sidebar as CommonSidebar } from 'scenes/common/components/Sidebar';
import { useAwards } from 'scenes/common/hooks/useAwards/useAwards';
import { isBeforeEffectiveEndDate } from 'scenes/common/selectors/configSelectors';
import { InsuranceName } from 'scenes/common/types';
import {
  shouldShowClaimCVP,
  showFlybuysInfoSection,
  showFooterQuoteInformation,
  showHeaderQuoteInformation,
  showSidebarMarketingCampaignInformation,
} from 'scenes/home/components/helpers';
import {
  getCampaign,
  getFirstInstalment,
  getMonthlyInstalment,
  getPolicyStartDate,
  getQuoteNumber,
  getSelectedInsuranceOption,
  getSelectedPaymentFrequency,
} from 'scenes/home/selectors';
import { HomeFullPageProps } from 'scenes/home/types';
import { listItems } from '../Footer/HassleFreeClaims';

export const Sidebar: FunctionComponent<Pick<
  HomeFullPageProps,
  'funnelState'
>> = ({ funnelState }) => {
  const { coverType, premium } = getSelectedInsuranceOption(funnelState);
  const { homeAwardsToDisplay } = useAwards();

  return (
    <CommonSidebar
      quoteNumber={getQuoteNumber(funnelState)}
      showMarketingCampaign={showSidebarMarketingCampaignInformation(
        funnelState.flow
      )}
      showQuotePrice={showHeaderQuoteInformation(
        funnelState.flow,
        funnelState.step
      )}
      showQuoteNumber={showFooterQuoteInformation(
        funnelState.flow,
        funnelState.step
      )}
      coverType={coverType}
      premium={premium}
      selectedPaymentFrequency={getSelectedPaymentFrequency(funnelState)}
      showSidebarFlybuysSection={showFlybuysInfoSection(funnelState.step)}
      campaign={getCampaign(funnelState)}
      insuranceName={InsuranceName.Home}
      firstInstalment={getFirstInstalment(funnelState)}
      followingMonths={getMonthlyInstalment(funnelState)}
      awardsToDisplay={homeAwardsToDisplay(funnelState).map((award) => () => (
        <AwardCard award={award} />
      ))}
      ClaimCvpComponent={
        shouldShowClaimCVP(funnelState) ? (
          <ClaimSupport items={listItems} />
        ) : null
      }
      isBeforeEffectiveEndDate={isBeforeEffectiveEndDate(
        funnelState.apiResponses.config,
        getPolicyStartDate(funnelState)
      )}
    />
  );
};

export default Sidebar;
